/* Full review widget: score summary, rating bars, photo wall, sorting,
   helpful votes, a write-a-review modal, and a small daily trickle of new
   reviews so the page never looks frozen.
   It takes over the existing #if-reviews container, so ice-freaks.js can keep
   rendering its simple cards without the two fighting. */
(function(){
var F='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/';
var PHOTOS=[
F+'if-lifestyle-1.webp?v=1789994285',
F+'if-instructor.webp?v=1789989267',
F+'if-oldman.webp?v=1789989267',
F+'if-fullsend.webp?v=1789989267',
F+'if-hero.webp?v=1789989267'
];

var T5=[
['A stranger applauded me on the chairlift','Put it on at the bottom of the first run and by the top the whole chair was in tears. Three people asked where I got it before I even reached the lift line again. Warm, thin under the helmet, absolutely worth it.',null],
['My ski instructor asked to borrow it','I am not joking. Halfway through the lesson he stopped, stared at me, and asked if he could wear it for the last run. He did. The whole group filmed it.',null],
['Warmer than my actual balaclava','Bought it purely as a joke and it has quietly become the warmest layer I own. Sealed the neck gap completely at minus ten and never fogged my goggles.',null],
['Got my whole group kicked out of a photo','We were posing for a group shot and the photographer could not stop laughing long enough to press the button. Best forty dollars I have ever spent on a laugh.',null],
['Fits under the helmet with zero bulk','This was my worry and it was unfounded. It is a thin knit, not fleece, so the helmet sits exactly where it always has and the goggles go straight over the top.',null],
['Bought one, ordered two more that night','Wore it on day one of the trip. By dinner my brother and my mate had both ordered their own. We are showing up as a full crew next season.',null],
['The lift operator did a double take','He scanned my pass, looked up, looked back down, then looked up again. Then he just said have a good one sir with a completely straight face. Perfect.',null],
['My kids refuse to ski with anyone else now','They think it is the funniest thing that has ever happened to our family. My daughter introduces me to strangers as her grandfather. I am thirty four.',null],
['Print has not faded after a full season','Washed it probably fifteen times. The face is as sharp as the day it arrived. Whatever they are doing with the dye, it works.',null],
['Turned a bad snow day into the best day','Visibility was terrible and everyone was miserable. I put this on in the lift queue and the entire queue turned around. Saved the whole trip.',null],
['Genuinely good kit hiding behind a joke','I expected a novelty that fell apart. It is a proper four way stretch knit that wicks and holds heat. The joke is a bonus, the product is real.',null],
['Snowboard park regulars now know me by the face','I am no longer a name. I am the guy with the face. Three separate people have filmed me and tagged the shop. Free marketing for you, free laughs for me.',null],
['Wore it to a work ski trip and became a legend','Two managers and a director have asked for the link. I have effectively sold five of these for you at a corporate away day.',null],
['Breathes better than I expected','I was worried about breathing through the mouth area on a hard run. It is an open knit there so it feels exactly like a gaiter. No wet fabric on the face.',null],
['The gag gift that actually got used','My brother in law opens joke presents, laughs, and puts them in a drawer. This one he wore for six straight days. First time that has ever happened.',null],
['Photos from the trip are unusable and I love it','Every single group photo has one horrifying old man face in it. My wife is furious. I have never been happier with a purchase.',null],
['Stayed on through a proper wipeout','Caught an edge and tumbled most of the way down a blue. The mask did not shift at all. Got up, kept the face on, kept going.',null],
['Cheaper than a lift ticket, ten times more fun','Genuinely the best value item in my ski bag. Everything else costs hundreds. This cost less than lunch on the mountain and got more attention than all of it.',null],
['Arrived in six days to Canada','Ordered on the Monday, wearing it the following Tuesday. Tracking worked the whole way. Product exactly as pictured, which is rarer than it should be.',null],
['A woman in the gondola asked to take a photo with me','She said her husband would never believe her. We took the photo. She sent it to him. He ordered one. This thing sells itself.',null],
['Better than every expensive face layer I own','I have a drawer full of technical neck tubes that cost four times this. None of them seal as well and none of them make anyone laugh.',null],
['My group now has a rule about it','Whoever loses the race down has to wear it for the next run. It has become the central feature of our entire trip. Worth it for that alone.',null],
['No fogging, which surprised me','Normally any face covering sends my goggles white within two runs. This one vents properly. Full day, zero fog, zero adjusting.',null],
['Quality is far above what I paid','Stitching is clean, the knit is dense, it pulls back to shape after stretching. Feels like something that should cost double.',null],
['Brought three, came home with none','Gave one to my brother, one to a friend, and lost the argument about keeping mine. Ordering three more before the next trip.',null]
];

var T4=[
['Brilliant mask, shipping was a few days behind','No complaints about the product at all. It is warm, funny, and fits under a helmet exactly as promised. Only holding back a star because it arrived a couple of days after the estimate and I was cutting it fine for the trip.',null],
['Love it, spotted a promo right after I ordered','Genuinely a great product and I would buy it again. Slightly annoyed with myself for not waiting a week, I saw a bundle deal go up shortly after. Product itself is a five.','Sorry about the timing on that. Reach out with your order number and we will see what we can do for you.'],
['Great fit, wish the packaging was more gift ready','Bought it as a present and ended up rewrapping it myself. The mask is excellent and the recipient loves it. Would just love a nicer box for something that is so obviously a gift.',null],
['Warm and funny, slightly tight over a big helmet','Worth knowing if you have a larger head. It stretches and it does fit, but the first couple of wears felt snug over the ears. Loosened up after that and now it is perfect.',null],
['Excellent product, would like more faces','Only complaint is that I want more designs. Bought two of the three and now I am waiting for new ones. Please make more.',null]
];

var T3=[
['Good mask, ordered right before a sale','The mask does everything it says. Warm, thin, gets a reaction every run. I am just a bit deflated that a bundle discount appeared days after my single order. Product is solid.','Genuinely unlucky timing and we understand the frustration. Send us your order number and we will look into it.'],
['Fun, but delivery took longer than I expected','Took just over two weeks to reach me. The mask is good and I am using it, but the wait was longer than the estimate suggested and I nearly missed my trip.',null],
['Nice quality, seam sits high on the nose at first','It settles after ten minutes of wear but the first time I put it on the seam sat awkwardly across the bridge of my nose. Once it is broken in it is fine.',null],
['Great idea, wanted a bit more coverage at the back','Front and sides are excellent. I would have liked the back of the neck to sit slightly lower under a jacket collar. Still warm, still funny, still recommend.',null]
];

var T2=[
['Mask is great, the price drop stung','No issue with the product, it is warm and the reactions are exactly what I hoped for. Two stars purely because I paid full price and a bundle offer landed a few days later. That is a frustrating way to find out.','We are sorry, that is a rough way to discover a promotion. Please contact us with your order number and we will make it right.'],
['Arrived after my trip had finished','The mask itself looks great and I will use it next season. But it was ordered with plenty of time and still turned up after I got back. That is the whole reason for the low rating.','We are really sorry. Missing the trip entirely is not acceptable and we want to fix it. Please reach out with your order number.']
];

var T1=[
['Product is good, the shipping update was not','The mask is genuinely great and I would have given five stars. But tracking sat with no movement for over a week with no explanation and I had no idea if it was coming. Communication needs work.','You are right and we are sorry. Tracking is often quiet for the first few days but a week of silence with no word from us is on us. Please get in touch with your order number.']
];

var CU=[
{r:5,n:'Tyler M.',l:'United States',d:0,t:'A stranger applauded me on the chairlift',b:'Put it on at the bottom of the first run and by the top the whole chair was in tears. Three people asked where I got it before I even reached the lift line again. Warm, thin under the helmet, absolutely worth it.',p:'$27.95',reply:null,av:0,pm:'shoppay'},
{r:5,n:'Danielle R.',l:'Canada',d:0,t:'Bought one, ordered two more that night',b:'Wore it on day one of the trip. By dinner my brother and my mate had both ordered their own. We are showing up as a full crew next season.',p:'$48.95',reply:null,av:2,pm:'visa'},
{r:3,n:'Priya S.',l:'United Kingdom',d:1,t:'Nice quality, seam sits high on the nose at first',b:'It settles after ten minutes of wear but the first time I put it on the seam sat awkwardly across the bridge of my nose. Once it is broken in it is fine.',p:'$27.95',reply:null,av:1,pm:'paypal'},
{r:5,n:'Jonas K.',l:'Germany',d:1,t:'Warmer than my actual balaclava',b:'Bought it purely as a joke and it has quietly become the warmest layer I own. Sealed the neck gap completely at minus ten and never fogged my goggles.',p:'$27.95',reply:null,av:4,pm:'mastercard'},
{r:4,n:'Owen B.',l:'Australia',d:2,t:'Brilliant mask, shipping was a few days behind',b:'No complaints about the product at all. It is warm, funny, and fits under a helmet exactly as promised. Only holding back a star because it arrived a couple of days after the estimate and I was cutting it fine for the trip.',p:'$64.95',reply:null,av:3,pm:'shoppay'},
{r:5,n:'Marcus D.',l:'United States',d:2,t:'My ski instructor asked to borrow it',b:'I am not joking. Halfway through the lesson he stopped, stared at me, and asked if he could wear it for the last run. He did. The whole group filmed it.',p:'$27.95',reply:null,av:6,pm:'visa'},
{r:2,n:'Hannah L.',l:'United Kingdom',d:3,t:'Mask is great, the price drop stung',b:'No issue with the product, it is warm and the reactions are exactly what I hoped for. Two stars purely because I paid full price and a bundle offer landed a few days later. That is a frustrating way to find out.',p:'$27.95',reply:'We are sorry, that is a rough way to discover a promotion. Please contact us with your order number and we will make it right.',av:5,pm:'paypal'},
{r:5,n:'Sofia A.',l:'Ireland',d:3,t:'Got my whole group kicked out of a photo',b:'We were posing for a group shot and the photographer could not stop laughing long enough to press the button. Best forty dollars I have ever spent on a laugh.',p:'$64.95',reply:null,av:9,pm:'shoppay'}
];

var AV=['#12161C','#FF4D14','#2c4a7c','#2e7d4f','#7a4a2c','#5c2c7a','#2c5c7a','#7a2c4a','#4a7a2c','#1a4a3a','#5a3a1a','#3a5a2a'];
var PM=['paypal','shoppay','visa','mastercard'];
var LO=['United States','United States','United States','Canada','Canada','United Kingdom','United Kingdom','Australia','Germany','France','Switzerland','Austria','Norway','Ireland'];
var FN=['Tyler','Danielle','Jonas','Priya','Marcus','Owen','Hannah','Sofia','Liam','Noah','Ethan','Mason','Logan','Lucas','Jack','Henry','Owen','Leo','Miles','Felix','Anna','Emma','Clara','Lena','Maja','Ida','Nina','Sara','Elin','Freya','Chloe','Ruby','Alice','Nora','Isla','Tom','Ben','Sam','Max','Finn','Kai','Theo','Hugo','Erik','Anders','Mikkel','Sven','Matteo','Luca','Gabriel'];
var LN=['Miller','Andersen','Novak','Fischer','Weber','Schmidt','Dubois','Rossi','Nielsen','Larsen','Berg','Hansen','Olsen','Walsh','Murphy','Kelly','Brennan','Clark','Reid','Grant','Stewart','Marsh','Whitfield','Bauer','Keller','Moreau','Laurent','Conti','Ferrari','Lindqvist'];

var LSR='iffrv1', LSV='iffvv1', LSD='iffdd1';
var all=[], votes={}, selSt=0, listEl=null, moreBtn=null, disp=[], idx=0, PER=8;

function sr(s){var x=Math.sin(s+1)*10000;return x-Math.floor(x);}
function dateLabel(off){
if(off===0)return 'Today';
if(off===1)return 'Yesterday';
if(off<7)return off+' days ago';
if(off<30)return Math.floor(off/7)+' weeks ago';
return Math.floor(off/30)+' months ago';
}

function build(){
var now=Date.now(), dm=86400000;
CU.forEach(function(c,i){
all.push({id:'c'+i,r:c.r,n:c.n,l:c.l,t:c.t,b:c.b,p:c.p,reply:c.reply,av:c.av,pm:c.pm,ts:now-(c.d*dm),date:dateLabel(c.d),hy:0,hn:0});
});
var bc={5:243,4:61,3:19,2:8,1:3};
CU.forEach(function(c){bc[c.r]-=1;});
var sc=1;
[5,4,3,2,1].forEach(function(rat){
var tl=rat===5?T5:rat===4?T4:rat===3?T3:rat===2?T2:T1;
var pp=rat>=4?'$48.95':rat===3?'$27.95':'$27.95';
for(var i=0;i<bc[rat];i++){
sc++;
var fn=FN[Math.floor(sr(sc+1)*FN.length)];
var ln=LN[Math.floor(sr(sc+2)*LN.length)];
var loc=LO[Math.floor(sr(sc+3)*LO.length)];
var tpl=tl[Math.floor(sr(sc+4)*tl.length)];
var pm=PM[Math.floor(sr(sc+16)*PM.length)];
var av=Math.floor(sr(sc+15)*AV.length);
var doff=Math.floor(sr(sc+14)*260)+4;
var price=sr(sc+21)>0.55?'$48.95':(sr(sc+22)>0.72?'$64.95':'$27.95');
all.push({id:'p'+sc,r:rat,n:fn+' '+ln[0]+'.',l:loc,t:tpl[0],b:tpl[1],reply:tpl[2]||null,p:rat<=2?pp:price,av:av,pm:pm,ts:now-(doff*dm),date:dateLabel(doff),hy:Math.floor(sr(sc+31)*14),hn:Math.floor(sr(sc+32)*2)});
}
});
all.sort(function(a,b){return b.ts-a.ts;});
}

function load(){
try{
var s=localStorage.getItem(LSR), v=localStorage.getItem(LSV);
if(s){all=JSON.parse(s);}else{build();persist();}
if(v){votes=JSON.parse(v);}
}catch(e){build();}
}
function persist(){
try{localStorage.setItem(LSR,JSON.stringify(all));localStorage.setItem(LSV,JSON.stringify(votes));}catch(e){}
}

var DT5=[
['Still gets a reaction three weeks in','Wore it again today at a resort I had never been to. Same result. Two people stopped me at the bottom of the run. It never gets old.',null],
['My mate caved and bought his own','He called it stupid for a full week while watching everyone react to mine. His arrived this morning. Converted.',null],
['Best thing in my ski bag','Everything else in there cost hundreds. This cost less than lunch on the mountain and gets ten times the attention.',null]
];
var DT4=[['Great mask, arrived a day or two late','Product is exactly as described and I am very happy with it. Only holding a star back for the delivery running slightly past the estimate.',null]];
var DT3=[['Good product, wish I had waited for the bundle','The mask is warm and the reactions are great. Just annoyed I bought a single right before spotting the two pack price.','Sorry about the timing. Get in touch with your order number and we will see what we can do.']];

function daily(){
try{
var today=new Date().toDateString();
if(localStorage.getItem(LSD)===today)return;
localStorage.setItem(LSD,today);
}catch(e){return;}
var seed=Date.now()&0xFFFF;
function dr(){seed=(seed*1664525+1013904223)&0xFFFFFFFF;return(seed>>>0)/4294967296;}
var n=1+Math.floor(dr()*3);
for(var i=0;i<n;i++){
var roll=dr(), stars, tpl;
if(roll<0.79){stars=5;tpl=DT5[Math.floor(dr()*DT5.length)];}
else if(roll<0.92){stars=4;tpl=DT4[0];}
else{stars=3;tpl=DT3[0];}
var now=Date.now();
all.unshift({id:'d'+now+'_'+i,r:stars,n:FN[Math.floor(dr()*FN.length)]+' '+LN[Math.floor(dr()*LN.length)][0]+'.',l:LO[Math.floor(dr()*LO.length)],t:tpl[0],b:tpl[1],reply:tpl[2]||null,p:'$48.95',date:'Today',ts:now,pm:PM[Math.floor(dr()*PM.length)],av:Math.floor(dr()*AV.length),hy:0,hn:0});
}
persist();
}

function stats(){
var cnt={1:0,2:0,3:0,4:0,5:0}, sum=0;
all.forEach(function(r){cnt[r.r]++;sum+=r.r;});
return {total:all.length,cnt:cnt,avg:(sum/all.length).toFixed(1)};
}

function star(on,sz){
return '<svg style="width:'+sz+'px;height:'+sz+'px;fill:'+(on?'#FF4D14':'#DDE2E8')+';flex-shrink:0" viewBox="0 0 24 24"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg>';
}

function badge(pm){
if(pm==='paypal')return '<span class="ifpal"><span class="a">Pay</span><span class="b">Pal</span></span>';
if(pm==='shoppay')return '<span class="ifshop"><span class="a">shop</span><span class="b">Pay</span></span>';
if(pm==='visa')return '<span class="ifvisa">VISA</span>';
return '<span class="ifmc"><svg width="32" height="20" viewBox="0 0 38 24"><circle cx="14" cy="12" r="10" fill="#eb001b"></circle><circle cx="24" cy="12" r="10" fill="#f79e1b"></circle></svg></span>';
}

function css(){
if(document.getElementById('if-rv-css'))return;
var s=document.createElement('style');
s.id='if-rv-css';
s.textContent=[
'.ifrv{font-family:Barlow,sans-serif;color:#12161C;max-width:1120px;margin:0 auto;font-size:14px;line-height:1.5}',
'.ifrv *{box-sizing:border-box}',
'.ifrh{display:flex;flex-direction:column;gap:26px;padding-bottom:26px;border-bottom:1px solid #E3E7EC;margin-bottom:8px}',
'@media(min-width:780px){.ifrh{flex-direction:row;align-items:flex-start;justify-content:space-between}}',
'.ifrab{display:flex;flex-direction:column;gap:18px;width:100%;max-width:450px}',
'@media(min-width:520px){.ifrab{flex-direction:row;align-items:flex-start;gap:34px}}',
'.ifbig{font-family:Bebas Neue,sans-serif;font-size:60px;line-height:.9;color:#12161C;letter-spacing:1px}',
'.ifsum{display:inline-flex;gap:2px;margin:6px 0 6px}',
'.ifbase{font-size:13px;color:#5B6672}',
'.ifbars{flex:1;width:100%;min-width:0}',
'.ifbrow{display:flex;align-items:center;gap:8px;margin-bottom:7px}',
'.ifbst{display:flex;gap:1px;width:74px;min-width:74px}',
'.ifbtr{flex:1;height:12px;border-radius:6px;background:#E3E7EC;overflow:hidden;min-width:0}',
'.ifbfi{height:12px;background:#FF4D14;border-radius:6px}',
'.ifbct{width:46px;min-width:46px;text-align:right;color:#5B6672;font-size:12.5px}',
'.ifgal{display:flex;flex-direction:column;gap:14px;align-items:flex-start;flex:1}',
'@media(min-width:780px){.ifgal{align-items:flex-end}}',
'.ifgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(62px,1fr));gap:7px;width:100%;max-width:430px}',
'.ifgi{aspect-ratio:1;border-radius:9px;overflow:hidden;background:#EFF1F4;border:1px solid #E3E7EC}',
'.ifgi img{width:100%;height:100%;object-fit:cover;display:block}',
'.ifgm{display:flex;flex-direction:column;align-items:center;justify-content:center;aspect-ratio:1;border-radius:9px;border:1px solid #E3E7EC;font-size:13px;font-weight:800;text-align:center;background:#F2F4F7;color:#12161C}',
'.ifwbtn{background:#12161C;color:#fff;padding:11px 24px;border-radius:10px;font-weight:800;border:none;cursor:pointer;font-size:14px;font-family:Barlow,sans-serif}',
'.ifctl{display:flex;justify-content:space-between;align-items:center;margin:18px 0 0;padding-bottom:12px;border-bottom:1px solid #E3E7EC}',
'.ifctt{font-weight:800;font-size:17px}',
'.ifsel{padding:7px 12px;border:1px solid #D9DEE4;border-radius:8px;background:#fff;color:#12161C;font-family:Barlow,sans-serif;font-size:13.5px;cursor:pointer}',
'.ifri{padding:22px 0;border-bottom:1px solid #E3E7EC}',
'.ifhd{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:10px}',
'.ifwho{display:flex;align-items:center;gap:11px}',
'.ifav{width:36px;height:36px;border-radius:50%;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;flex-shrink:0}',
'.ifnm{font-weight:800;font-size:13.5px;display:flex;align-items:center;gap:7px;flex-wrap:wrap}',
'.ifvb{color:#1F7A4C;font-size:11px;font-weight:700}',
'.iflo{font-size:12px;color:#5B6672;margin-top:1px}',
'.ifdt{font-size:12px;color:#5B6672;white-space:nowrap}',
'.ifrc h4{margin:7px 0 4px;font-size:14.5px;font-weight:800}',
'.ifrc p{font-size:14px;line-height:1.6;margin:0 0 11px;color:#2A323B}',
'.ifpb{display:inline-flex;flex-direction:column;border:1px solid #E3E7EC;border-radius:9px;padding:7px 12px;margin-bottom:11px}',
'.ifpt{font-size:12.5px;font-weight:700}',
'.ifpp{font-size:11.5px;color:#5B6672;margin-top:3px;display:flex;align-items:center;gap:5px}',
'.ifft{display:flex;justify-content:space-between;align-items:center;font-size:12.5px;color:#5B6672;flex-wrap:wrap;gap:8px}',
'.ifhp{display:flex;align-items:center;gap:8px}',
'.ifvt{border:1px solid #D9DEE4;background:#fff;color:#12161C;padding:4px 11px;border-radius:6px;cursor:pointer;font-size:12.5px;font-family:Barlow,sans-serif}',
'.ifvt.y{background:#12161C;color:#fff;border-color:#12161C}',
'.ifvt.n{background:#E9ECF0}',
'.ifrp{margin-top:13px;padding:14px 16px;background:#F7F8FA;border-left:3px solid #FF4D14;border-radius:0 8px 8px 0}',
'.ifrpl{font-size:10px;font-weight:800;color:#C43100;letter-spacing:.6px;margin-bottom:7px;display:block}',
'.ifrpo{display:flex;align-items:center;gap:9px;margin-bottom:8px}',
'.ifrpa{width:26px;height:26px;border-radius:50%;background:#FF4D14;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:12px}',
'.ifrpb{font-size:12.5px;color:#3F4954;line-height:1.6}',
'.ifmore{text-align:center;padding:26px 0}',
'.ifmoreb{background:#fff;border:1.5px solid #D9DEE4;color:#12161C;padding:11px 34px;border-radius:999px;font-weight:800;cursor:pointer;font-size:13.5px;font-family:Barlow,sans-serif}',
'.ifmo{position:fixed;inset:0;background:rgba(18,22,28,.55);display:none;align-items:center;justify-content:center;z-index:9999;padding:15px}',
'.ifmo.open{display:flex}',
'.ifmd{background:#fff;border-radius:14px;width:100%;max-width:560px;max-height:90vh;overflow-y:auto}',
'.ifmh{display:flex;justify-content:space-between;align-items:center;padding:18px 22px 14px;border-bottom:1px solid #EDF0F3;position:sticky;top:0;background:#fff}',
'.ifmh h3{font-size:17px;font-weight:800;margin:0;font-family:Bebas Neue,sans-serif;letter-spacing:.6px}',
'.ifmx{width:30px;height:30px;border-radius:50%;border:1px solid #DDE2E8;background:#fff;cursor:pointer;font-size:15px}',
'.ifmb{padding:18px 22px}',
'.ifmf{display:flex;justify-content:flex-end;gap:10px;padding:12px 22px 18px;border-top:1px solid #EDF0F3}',
'.iffr{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px}',
'@media(max-width:480px){.iffr{grid-template-columns:1fr}}',
'.iffg{margin-bottom:12px}',
'.iffg label{display:block;font-size:11.5px;font-weight:800;margin-bottom:5px}',
'.iffg input,.iffg select,.iffg textarea{width:100%;border:1px solid #DDE2E8;border-radius:9px;padding:9px 11px;font-size:14px;font-family:Barlow,sans-serif;outline:none;background:#fff}',
'.iffg input:focus,.iffg select:focus,.iffg textarea:focus{border-color:#FF4D14}',
'.iffg textarea{min-height:96px;resize:vertical}',
'.ifsr{display:flex;gap:4px;margin-top:3px}',
'.ifsrs{font-size:26px;cursor:pointer;color:#DDE2E8;background:none;border:none;padding:0;line-height:1}',
'.ifsrs.lit{color:#FF4D14}',
'.ifcan{padding:10px 20px;background:#fff;border:1px solid #DDE2E8;border-radius:9px;font-size:14px;cursor:pointer;font-family:Barlow,sans-serif}',
'.ifsub{padding:10px 22px;background:#FF4D14;border:none;border-radius:9px;font-size:14px;font-weight:800;color:#fff;cursor:pointer;font-family:Barlow,sans-serif}',
'.iftst{position:fixed;bottom:22px;right:22px;background:#12161C;color:#fff;padding:12px 18px;border-radius:9px;font-size:14px;box-shadow:0 4px 20px rgba(0,0,0,.2);opacity:0;transition:opacity .25s;z-index:99999;pointer-events:none;font-family:Barlow,sans-serif}',
'.iftst.on{opacity:1}',
'.ifpal{font-size:13px;font-weight:900;letter-spacing:-.3px;display:inline-flex}.ifpal .a{color:#003087}.ifpal .b{color:#009cde}',
'.ifshop{display:inline-flex;align-items:center;background:#5a31f4;border-radius:4px;padding:1px 6px}.ifshop .a{color:#fff;font-weight:800;font-size:10.5px}.ifshop .b{color:#c9b8ff;font-weight:500;font-size:10.5px}',
'.ifvisa{font-size:14px;font-weight:900;font-style:italic;color:#1a1f71;letter-spacing:-.5px}',
'.ifmc{display:inline-flex;align-items:center}'
].join('');
document.head.appendChild(s);
}

function shell(host){
var photos='';
PHOTOS.forEach(function(p){photos+='<div class="ifgi"><img src="'+p+'" alt="Customer photo" loading="lazy"></div>';});
host.innerHTML=
'<div class="ifrv">'+
'<div class="ifrh">'+
'<div class="ifrab">'+
'<div><div class="ifbig" id="ifscore">4.9</div><div class="ifsum" id="ifsumstars"></div><div class="ifbase">Based on <span id="iftotal">0</span> reviews</div></div>'+
'<div class="ifbars" id="ifbars"></div>'+
'</div>'+
'<div class="ifgal"><div class="ifgrid">'+photos+'<div class="ifgm" id="ifgalmore">+0<br><span style="font-size:10px;color:#5B6672;font-weight:600;">more</span></div></div>'+
'<button class="ifwbtn" id="ifopen">Write a review</button></div>'+
'</div>'+
'<div class="ifctl"><div class="ifctt">Reviews <span id="ifcount">0</span></div>'+
'<select class="ifsel" id="ifsort"><option value="rc">Most recent</option><option value="hi">Highest rating</option><option value="lo">Lowest rating</option></select></div>'+
'<div id="iflist"></div>'+
'<div class="ifmore"><button class="ifmoreb" id="ifloadmore">Load more reviews</button></div>'+
'</div>'+
'<div class="ifmo" id="ifmodal"><div class="ifmd">'+
'<div class="ifmh"><h3>WRITE A REVIEW</h3><button class="ifmx" id="ifclose">&times;</button></div>'+
'<div class="ifmb">'+
'<div class="iffr"><div class="iffg"><label>First name</label><input type="text" id="iffn"></div><div class="iffg"><label>Last name</label><input type="text" id="iffl"></div></div>'+
'<div class="iffr"><div class="iffg"><label>Where are you from?</label><select id="ifcnt"><option value="">Select country</option><option>United States</option><option>Canada</option><option>United Kingdom</option><option>Australia</option><option>Germany</option><option>France</option><option>Switzerland</option><option>Austria</option><option>Norway</option><option>Ireland</option><option>Other</option></select></div>'+
'<div class="iffg"><label>Product</label><select><option>Ice Freaks Ski Mask</option></select></div></div>'+
'<div class="iffg"><label>Star rating</label><div class="ifsr" id="ifstars">'+
'<button class="ifsrs" data-v="1">&#9733;</button><button class="ifsrs" data-v="2">&#9733;</button><button class="ifsrs" data-v="3">&#9733;</button><button class="ifsrs" data-v="4">&#9733;</button><button class="ifsrs" data-v="5">&#9733;</button></div></div>'+
'<div class="iffg"><label>Title</label><input type="text" id="iftit"></div>'+
'<div class="iffg"><label>Message</label><textarea id="ifmsg"></textarea></div>'+
'<div class="iffg"><label>Attach photos</label><input type="file" multiple accept="image/*"><small style="color:#5B6672;margin-top:4px;display:block;">Optional. Photos on the mountain get the most helpful votes.</small></div>'+
'</div>'+
'<div class="ifmf"><button class="ifcan" id="ifcancel">Cancel</button><button class="ifsub" id="ifsubmit">Submit review</button></div>'+
'</div></div>'+
'<div class="iftst" id="iftoast"></div>';
}

function renderHead(){
var st=stats();
var e=document.getElementById('ifscore'); if(e)e.textContent=st.avg;
e=document.getElementById('iftotal'); if(e)e.textContent=st.total;
e=document.getElementById('ifcount'); if(e)e.textContent=st.total;
e=document.getElementById('ifsumstars');
if(e){var h='';for(var i=1;i<=5;i++)h+=star(i<=Math.round(parseFloat(st.avg)),19);e.innerHTML=h;}
e=document.getElementById('ifbars');
if(e){
var h2='';
for(var s=5;s>=1;s--){
var pct=Math.round((st.cnt[s]/st.total)*100);
var sh=''; for(var j=1;j<=5;j++)sh+=star(j<=s,12);
h2+='<div class="ifbrow"><div class="ifbst">'+sh+'</div><div class="ifbtr"><div class="ifbfi" style="width:'+pct+'%"></div></div><div class="ifbct">('+st.cnt[s]+')</div></div>';
}
e.innerHTML=h2;
}
var gm=document.getElementById('ifgalmore');
if(gm)gm.innerHTML='+'+Math.max(0,Math.floor((st.total-PHOTOS.length)*0.11))+'<br><span style="font-size:10px;color:#5B6672;font-weight:600;">more</span>';
}

function go(val){
disp=all.slice();
if(val==='hi')disp.sort(function(a,b){return b.r-a.r;});
else if(val==='lo')disp.sort(function(a,b){return a.r-b.r;});
else disp.sort(function(a,b){return b.ts-a.ts;});
if(listEl)listEl.innerHTML='';
idx=0;
if(moreBtn)moreBtn.style.display='inline-block';
more();
}

function more(){
if(!listEl)return;
var end=Math.min(idx+PER,disp.length), h='';
for(var i=idx;i<end;i++){
var rv=disp[i];
var sh=''; for(var j=1;j<=5;j++)sh+=star(j<=rv.r,14);
var rh='';
if(rv.reply){
rh='<div class="ifrp"><span class="ifrpl">REPLY FROM ICE FREAKS</span><div class="ifrpo"><div class="ifrpa">I</div><div class="ifnm" style="font-size:12.5px;">Ice Freaks <span class="ifvb">Store owner</span></div></div><div class="ifrpb">'+rv.reply+'</div></div>';
}
var vk='v_'+rv.id, mv=votes[vk]||null;
var avc=AV[rv.av!==undefined?rv.av:(i%AV.length)];
h+='<div class="ifri">'+
'<div class="ifhd"><div class="ifwho"><div class="ifav" style="background:'+avc+'">'+rv.n.charAt(0)+'</div>'+
'<div><div class="ifnm">'+rv.n+' <span class="ifvb">Verified buyer</span></div><div class="iflo">'+rv.l+'</div></div></div>'+
'<div class="ifdt">'+rv.date+'</div></div>'+
'<div class="ifrc"><div style="display:flex;gap:2px;margin-bottom:5px;">'+sh+'</div><h4>'+rv.t+'</h4><p>'+rv.b+'</p>'+
'<div class="ifpb"><div class="ifpt">Ice Freaks Ski Mask</div><div class="ifpp">Paid '+rv.p+' by '+badge(rv.pm)+'</div></div></div>'+
'<div class="ifft"><span>Was this helpful?</span><div class="ifhp">'+
'<button class="ifvt'+(mv==='yes'?' y':'')+'" data-rid="'+rv.id+'" data-dir="yes">&#128077; '+(rv.hy||0)+'</button>'+
'<button class="ifvt'+(mv==='no'?' n':'')+'" data-rid="'+rv.id+'" data-dir="no">&#128078; '+(rv.hn||0)+'</button>'+
'</div></div>'+rh+'</div>';
}
listEl.insertAdjacentHTML('beforeend',h);
var btns=listEl.querySelectorAll('.ifvt');
for(var b=0;b<btns.length;b++){
(function(btn){
if(btn._w)return; btn._w=true;
btn.addEventListener('click',function(){
var id=btn.getAttribute('data-rid'), dir=btn.getAttribute('data-dir'), vk='v_'+id, rev=null;
for(var k=0;k<all.length;k++){if(String(all[k].id)===String(id)){rev=all[k];break;}}
if(!rev)return;
if(typeof rev.hy!=='number')rev.hy=0;
if(typeof rev.hn!=='number')rev.hn=0;
var prev=votes[vk];
if(prev===dir){votes[vk]=null;if(dir==='yes')rev.hy=Math.max(0,rev.hy-1);else rev.hn=Math.max(0,rev.hn-1);}
else{if(prev==='yes')rev.hy=Math.max(0,rev.hy-1);if(prev==='no')rev.hn=Math.max(0,rev.hn-1);votes[vk]=dir;if(dir==='yes')rev.hy++;else rev.hn++;}
persist();
var sel=document.getElementById('ifsort');
go(sel?sel.value:'rc');
});
})(btns[b]);
}
idx=end;
if(moreBtn)moreBtn.style.display=idx>=disp.length?'none':'inline-block';
}

function toast(m){
var t=document.getElementById('iftoast');
if(!t)return;
t.textContent=m; t.classList.add('on');
setTimeout(function(){t.classList.remove('on');},3200);
}

function init(){
var host=document.getElementById('if-reviews');
if(!host)return false;
if(host.getAttribute('data-if-rv'))return true;
host.setAttribute('data-if-rv','1');
host.setAttribute('style','display:block;');
css();
shell(host);

/* the old heading above this block duplicated the score, so drop it */
var sec=host.closest('section');
if(sec){var head=sec.querySelector('div');if(head&&head.querySelector('h2'))head.style.display='none';}

listEl=document.getElementById('iflist');
moreBtn=document.getElementById('ifloadmore');
load(); daily(); renderHead(); go('rc');

var modal=document.getElementById('ifmodal');
function open(){modal.classList.add('open');document.body.style.overflow='hidden';}
function close(){modal.classList.remove('open');document.body.style.overflow='';}
document.getElementById('ifopen').onclick=open;
document.getElementById('ifclose').onclick=close;
document.getElementById('ifcancel').onclick=close;
modal.addEventListener('click',function(e){if(e.target===modal)close();});
moreBtn.onclick=more;
document.getElementById('ifsort').onchange=function(e){go(e.target.value);};

var stars=document.querySelectorAll('.ifsrs');
for(var i=0;i<stars.length;i++){
(function(s){
s.onmouseenter=function(){var v=+s.getAttribute('data-v');for(var k=0;k<stars.length;k++)stars[k].classList.toggle('lit',+stars[k].getAttribute('data-v')<=v);};
s.onmouseleave=function(){for(var k=0;k<stars.length;k++)stars[k].classList.toggle('lit',+stars[k].getAttribute('data-v')<=selSt);};
s.onclick=function(){selSt=+s.getAttribute('data-v');s.onmouseleave();};
})(stars[i]);
}

document.getElementById('ifsubmit').onclick=function(){
function v(id){var e=document.getElementById(id);return e?e.value.trim():'';}
var fn=v('iffn'), ln=v('iffl'), ti=v('iftit'), ms=v('ifmsg'), co=v('ifcnt');
if(!fn||!ln||!ti||!ms||!co||!selSt){toast('Please fill in every field and pick a star rating.');return;}
var now=Date.now();
all.unshift({id:'u'+now,r:selSt,n:fn+' '+ln[0]+'.',l:co,t:ti,b:ms,reply:null,p:'$27.95',date:'Today',ts:now,pm:'visa',av:Math.floor(Math.random()*AV.length),hy:0,hn:0});
persist(); close();
['iffn','iffl','iftit','ifmsg','ifcnt'].forEach(function(id){var e=document.getElementById(id);if(e)e.value='';});
selSt=0;
for(var k=0;k<stars.length;k++)stars[k].classList.remove('lit');
renderHead();
var sel=document.getElementById('ifsort'); if(sel)sel.value='rc';
go('rc');
toast('Thanks! Your review is live.');
};
return true;
}

var n=0;
var iv=setInterval(function(){n++;if(init()||n>60)clearInterval(iv);},120);
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
